var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H14.1667M14.1667 15H27.5M14.1667 15V26.6666C14.1667 27.1087 14.3423 27.5326 14.6548 27.8451C14.9674 28.1577 15.3913 28.3333 15.8333 28.3333H24.1667C24.6087 28.3333 25.0326 28.1577 25.3452 27.8451C25.6577 27.5326 25.8333 27.1087 25.8333 26.6666V15H14.1667ZM16.6667 15V13.3333C16.6667 12.8913 16.8423 12.4673 17.1548 12.1548C17.4674 11.8422 17.8913 11.6666 18.3333 11.6666H21.6667C22.1087 11.6666 22.5326 11.8422 22.8452 12.1548C23.1577 12.4673 23.3333 12.8913 23.3333 13.3333V15M18.3333 19.1666V24.1666M21.6667 19.1666V24.1666",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.19a358280887a2f19128ad6f448a6a7c.svg";
export { ForwardRef as ReactComponent };